import axios from 'axios';
import { TAdminPosterDetailResponse } from 'types';

const getAdminPosterDetail = async (
  id: number,
): Promise<TAdminPosterDetailResponse> => {
  const res = await axios
    .get(`admin-poster/detail/${id}`)
    .then(function (response) {
      return response.data;
    });

  return res;
};

export { getAdminPosterDetail };
